import React, { useState } from 'react'
import FloatingActionButton from '../../ui/FloatingActionButton'
import AddIcon from '@mui/icons-material/Add'
import { Link as RouterLink } from 'react-router-dom'
import { Paper, Stack } from '@mui/material'
import {
  useDeleteWarrantyRegistration,
  useGetWarrantyRegistrations,
} from '../../../hooks/api/warranty'
import WarrantyRegistrationView from './WarrantyRegistrationView'
import { useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'
import { DialogYesNo } from '../../ui/DialogYesNo'

const WarrantyRegistrationsList = () => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [search, setSearch] = useState('')
  const [expanded, setExpanded] = useState(null)
  const { data } = useGetWarrantyRegistrations({ q: search, page: page + 1, limit: rowsPerPage })

  const queryClient = useQueryClient()
  const { mutateAsync: deleteWarrantyRegistration } = useDeleteWarrantyRegistration()
  const { enqueueSnackbar } = useSnackbar()

  const [idToDelete, setIdToDelete] = useState(null)
  const [openDelete, setOpenDelete] = useState(false)
  const onDelete = async (id) => {
    setIdToDelete(id)
    setOpenDelete(true)
  }

  const onDeleteConfirm = async (id) => {
    try {
      setOpenDelete(false)
      const res = await deleteWarrantyRegistration(id)
      queryClient.invalidateQueries(['warranty'])
      enqueueSnackbar(`Warranty registration ${res?.data?.id} has been deleted successfully.`, {
        variant: 'success',
      })
    } catch (err) {
      enqueueSnackbar(err?.message, { variant: 'error' })
    }
  }

  return (
    <>
      <Stack rowGap={{ xs: 1, md: 2 }}>
        {(data?.docs || []).map((d, index) => (
          <Paper sx={{ p: 1 }} key={d._id ?? index}>
            <WarrantyRegistrationView data={d} onDelete={onDelete} />
          </Paper>
        ))}
      </Stack>
      <FloatingActionButton
        color='primary'
        icon={<AddIcon />}
        label='Register'
        in
        variant='extended'
        component={RouterLink}
        to='/register-warranty'
      />
      <DialogYesNo
        open={openDelete}
        title='Are you sure?'
        prompt={`Do you want to delete ${idToDelete}? This process cannot be undone.`}
        textYes='Yes, delete it'
        onClose={() => setOpenDelete(false)}
        onConfirm={() => onDeleteConfirm(idToDelete)}
      />
    </>
  )
}

export default WarrantyRegistrationsList
